/**
 * Product-level feature toggles for the web client.
 *
 * These gate *entry points*, not implementations — the underlying pages,
 * routes and hooks stay wired up so a flag flip is all it takes to bring a
 * surface back.
 */

/**
 * Whether the "Watch Live" entry point renders on the rodeo detail page.
 *
 * Off while all scoring is done after the fact: the live view has nothing to
 * show, so the button only leads contestants to an empty page. The
 * `/rodeos/:rodeoId/live` route and `RodeoLivePage` remain intact and reachable
 * by direct link — flip this back to `true` to restore the button.
 */
export const WATCH_LIVE_ENABLED: boolean = false;
